/* eslint-disable camelcase */
export interface CustomEditorProps {
    readOnly: boolean;
    code: string;
    onCodeChange?: (code: string) => void;
    codeSections?: CodeSection[];
    language?: string;
    theme?: EditorTheme;
    id: string;
}

export interface CustomEditorWrapperProps extends CustomEditorProps {
    includeActions?: boolean;
    mainAction?: () => void;
    secondaryAction?: () => void;
    headerVariant: HeaderVariant;
    footerVariant?: FooterVariant;
    userLogo?: string;
    userNickname: string;
    completedMask?: boolean;
    percentage?: number;
    outOfTries?: boolean;
    headerActions?: Function;
    isGameDone?: boolean;
}

export enum HeaderVariant {
    VULNERABLE = 'vulnerable',
    REMEDIATION = 'remediation'
}

export enum FooterVariant {
    DONE = 'done',
    READ_ONLY = 'readOnly',
    END_GAME = 'endGame',
    SUBMIT = 'submit',
    SUBMIT_DISABLED = 'submitDisabled',
    LOADING = 'loading',
    RESULT = 'result'
}

export interface CodeSection {
    isCorrect: boolean;
    description?: string;
    startLine: number;
    endLine: number;
}

export enum EditorTheme {
    LIGHT = 'light',
    VSDARK = 'vs-dark'
}

export enum LanguageMapping {
    dotnet = 'csharp',
    android = 'java',
    angular = 'typescript',
    nodejs = 'javascript',
    scala = 'java',
    asp = 'csharp',
    cplus = 'cpp',
    groovy = 'java',
    vb6 = 'vb',
    booking = 'javascript',
    ios = 'swift',
    perl_client_side_edition = 'perl',
    perl_java = 'perl',
    tweddle = 'java',
    react = 'javascript'
}
